import React, { FC } from "react";

import "./Overlay.scss";

interface IOverlayProps {
	"data-testid"?: string;
	line1?: string;
	line2?: string;
}

const Overlay: FC<IOverlayProps> = (props) => {
	const { line1 = "Sending your order...", line2 = "Don't close this page." } = props;

	return (
		<div data-testid={props["data-testid"] ?? "Overlay"} className={"OverlayContainer"}>
			<div className="OverlayBG" />
			<div className="OverlayInfo">{line1}</div>
			<div className="OverlayInfo">{line2}</div>
		</div>
	);
};

export default React.memo(Overlay);
